module.exports = __webpack_public_path__ + "img/268.4eb8e3d9.gif";